import React from 'react';
import { TabelaPerfisDuplicados } from '../../components/TabelaPerfisDuplicados';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';


export default function PerfisDuplicadosPage() {

  return (
    <div className="p-pt-0">
      <MenuMain >
        <TabelaPerfisDuplicados />
      </MenuMain>
      <AppFooter />
    </div>
  );
}